var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from "vue-property-decorator";
import axios from "axios";
let Orderer = class Orderer extends Vue {
    controll = "";
    color = "#F44336";
    text = "";
    snackbar = false;
    material = [];
    date = "";
    dia = false;
    index = 0;
    timeout = -1;
    note = "";
    warehourse = false;
    headers = [
        { text: 'Format', value: 'format' },
        { text: 'Material', value: 'material' },
        { text: 'Dicke', value: 'thickness' },
        { text: 'Anzahl', value: 'quantity' },
        { text: 'Notiz', value: 'note' },
        { text: 'Lieferdatum', value: 'delivery_date' },
        { text: 'auf lager', value: 'goods_available' },
        { text: 'Aktionen', value: 'actions' },
    ];
    getmaterial() {
        axios.get('/api/assigment/' + this.controll + "/job").then((response) => {
            this.material = response.data.data;
        });
        return this.material;
    }
    assigmentedit() {
        if (this.index >= 0) {
            this.material[this.index]['delivery_date'] = this.date;
            this.material[this.index]['goods_available'] = this.warehourse;
            this.material[this.index]['note'] = this.note;
            //this.worklogs.splice(index, 1);
        }
    }
    sendAssignments() {
        axios.put('/api/assigment/' + this.controll + "/order", { material: this.material }).then((response) => {
            this.text = "Die Materialien wurden erfolgreich gespeichert";
            this.color = "green";
            this.snackbar = true;
        }).catch((error) => {
            this.text = "Die Materialien wurden nicht erfolgreich gespeichert";
            this.color = "red";
            this.snackbar = true;
        });
    }
    checkinstock() {
        if (this.warehourse) {
            this.date = new Date().toLocaleDateString('en-CA');
        }
    }
    diaopen(item) {
        this.dia = true;
        this.index = this.material.indexOf(item);
        this.date = this.material[this.index]['delivery_date'];
        this.warehourse = this.material[this.index]['goods_available'];
        this.note = this.material[this.index]['note'];
    }
    diaclose() {
        this.dia = false;
        this.date = "";
    }
    mounted() {
        if (this.$store.getters.isLoggedIn) {
            this.$store.state.monitor = false;
        }
        else {
            this.$store.commit('logout');
        }
    }
};
Orderer = __decorate([
    Component({
        name: "Orderer",
    })
], Orderer);
export default Orderer;
